<template>
  <div class="materials-list">
    <div
      class="material-item"
      v-for="material in materials"
      :key="material.id"
    >
      <div class="material-icon">
        <i :class="`fa-solid ${material.icon} ${material.color}`"></i>
      </div>

      <div class="material-content">
        <div class="material-title">
          <a
            :href="material.uuid_url || material.url"
            target="_blank"
          >
            {{ material.title }}
          </a>
        </div>
        <div class="material-desc">{{ material.comments }}</div>
      </div>

      <div class="material-action">
        <a
          :href="material.uuid_url || material.url"
          target="_blank"
          class="action-icon"
        >
          <i class="fa-solid" :class="material.uuid_url ? 'fa-download' : 'fa-link-horizontal'"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    materials: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.materials-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0;
}

.material-item {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
}

.material-icon {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 16px;
  flex-shrink: 0;
  font-size: 20px;
}

.material-content {
  flex: 1;
}

.material-title a {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  text-decoration: none;
}

.material-title a:hover {
  text-decoration: underline;
}

.material-desc {
  font-size: 0.95rem;
  color: #666;
}

.material-action {
  margin-left: 12px;
}

.action-icon {
  color: #1976d2;
  font-size: 20px;
}
</style>
